module.exports = __webpack_public_path__ + "static/a-xx-040-art-953e7347060bd3fe8cd8095844d5d301.jpg";